import { createSlice } from "@reduxjs/toolkit";
import { IUser } from "../../shared/interfaces/user/IUser";

export interface IAuthState {
  isAuthenticated: boolean;
  token: string;
  userData?: IUser;
}

const initialState: IAuthState = {
  isAuthenticated: false,
  token: "",
  userData: {
    // role: ERole.USER,
    id: 0,
    createdAt: "",
    updatedAt: "",
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    roles: [],
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoginState: (state, action) => {
      state = action.payload;
      return state;
    },
    setLogoutState: (state) => {
      state = initialState;
      return state;
    },
  },
});

export default authSlice;
